module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LE_SOL_MEGALITH_MEGABLACK.6edb8698.png";